import { render, staticRenderFns } from "./DocumentUploadSection.vue?vue&type=template&id=8658ad1c&scoped=true&"
import script from "./DocumentUploadSection.vue?vue&type=script&lang=js&"
export * from "./DocumentUploadSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUploadSection.vue?vue&type=style&index=0&id=8658ad1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8658ad1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VChip,VFileInput,VIcon,VList,VListItem,VListItemTitle,VMenu})
